import { render, staticRenderFns } from "./AssessmentCard.vue?vue&type=template&id=5007388d&scoped=true"
import script from "./AssessmentCard.vue?vue&type=script&lang=ts"
export * from "./AssessmentCard.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentCard.vue?vue&type=style&index=0&id=5007388d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5007388d",
  null
  
)

export default component.exports